<template>
  <div>
    <div class="corner top-left"></div>
    <div class="corner top-right"></div>
    <div class="corner bottom-left"></div>
    <div class="corner bottom-right"></div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.corner {
  position: absolute;
  width: 10px;
  height: 10px;
}
.top-left {
  left: 0;
  top: 0;
  border-top: 2px solid #00ddff;
  border-left: 2px solid #00ddff;
  margin: -1px 0 0 -1px;
}
.top-right {
  right: 0;
  top: 0;
  border-top: 2px solid #00ddff;
  border-right: 2px solid #00ddff;
  margin: -1px -1px 0 0;
}
.bottom-left {
  left: 0;
  bottom: 0;
  border-left: 2px solid #00ddff;
  border-bottom: 2px solid #00ddff;
  margin: 0 0 -1px -1px;
}
.bottom-right {
  right: 0;
  bottom: 0;
  border-right: 2px solid #00ddff;
  border-bottom: 2px solid #00ddff;
  margin: 0 -1px -1px 0;
}
</style>